export default __webpack_public_path__ + "static/media/apply-search.8df67483.svg";